import axios from 'axios';
import {errorHandler} from "./libs/lib.js";
import moment from 'moment';

const addKeys = ['tgl1','tgl2','partnerTransactionID','partnerLoanID'];

export default {
    list(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const keysDef = ['page', 'limit', 'sortBy', 'sortDir'];
                const keys = keysDef.concat(addKeys);
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/interest${str}`;
                const { data } = await axios.get(url);    
                const { meta, list } = data;
                for (const key in meta) {
                    obj[key]=meta[key];
                }
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/interest/exportxls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `daily_interest_${moment().format('YYYYMMDDHHmm')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    recalcdailyinterest(obj){
        return new Promise(async (resolve, reject) => {
            try {
                const url = `/interest/recalc-daily-interest`;
                const { data } = await axios.post(url,obj);    
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
};